$(function(){
  var discountCodeDataForTiles = document.querySelector('#discount-code-data') ? JSON.parse(document.querySelector('#discount-code-data').innerText) : {};
  let hypePageProduct = undefined;
  if (document.querySelector('body.template-page-hype-erg')) {
      let productDataEl = document.querySelector('#variant-inspect-product');
      if (productDataEl) {
          hypePageProduct = JSON.parse(productDataEl.textContent);
      }
  }
    /* show more open/close */

    function initShowMore(){
        $(document).on('click', '.show-more', function(e){
            var showmore = $(this)
            var parent = $(this).closest('.collection-wrapper')
            var details = $(this).closest('.product-tile__expandable-details-shown').next();

            var index = $(this).closest('.product-tile').attr('data-index');
            var openCarousels = parent.find(`.product-tile:not([data-index="${index}"]) .show-more[data-status="open"]`);
            var detailsHeight = details.find('.product-tile__expandable-details-hidden-inner-container').css("height");
            var shownHeight = $(this).closest('.product-tile__expandable-details-shown').css("height");
            var isBottomRow = (parseInt(index) + 4) % 4 == 2 || (parseInt(index) + 4) % 4 == 3 ? true : false;
            var imageCardRefreshNecessary = window.innerWidth >= 1024 && document.querySelectorAll('.image-card__card-tiles-container').length > 0 ? true : false;
            var opening = true;
            var cardImageIndex = Math.round((parseInt(index) + 1) / 4) - 1

            openCarousels.each(function() {
              $(this).text('Details');
              $(this).attr('data-status', 'closed');
              var openDetails = $(this).closest('.product-tile__expandable-details-shown').next();
              openDetails.css("height", "0px")            
              var openCarouselIndex = $(this).closest('.product-tile').attr('data-index');
              var openCarouselIsBottomRow = (parseInt(openCarouselIndex) + 4) % 4 == 2 || (parseInt(openCarouselIndex) + 4) % 4 == 3 ? true : false;

              if(imageCardRefreshNecessary == true && window.Branch && window.Branch.collection && window.Branch.collection.imageCardStyling){
                window.Branch.collection.imageCardStyling(window.innerWidth, 'onTileExpand', parseInt(detailsHeight.replace('px', '')), parseInt(shownHeight.replace('px', '')), openCarouselIsBottomRow, false, cardImageIndex)
            }
            })

            let openClose = function(){
              if(details.css('height') == '0px') {
                showmore.text('Close');
                showmore.attr('data-status', 'open');
                details.css("height", `${detailsHeight}`)
               
            } else {
                showmore.text('Details');
                showmore.attr('data-status', 'closed');
                details.css("height", "0px");
                opening = false;
              }
            if(imageCardRefreshNecessary == true && window.Branch && window.Branch.collection && window.Branch.collection.imageCardStyling){
                window.Branch.collection.imageCardStyling(window.innerWidth, 'onTileExpand', parseInt(detailsHeight.replace('px', )), parseInt(shownHeight.replace('px', '')), isBottomRow, opening, cardImageIndex)
            }
            }

            if(openCarousels.length > 0){ 
              setTimeout(() => {
                openClose()
              }, "500");
            } else {
              openClose()
            }

            
        })
    }

    const variantInspectSectionSpecialBehaviour = function(selected_variant, selectionImage, selectionImageInner, variantInspectionData, product){
      if(variantInspectionData){
        if(variantInspectionData[`${selected_variant.id}`]){
          imageSrcSet = window.Branch.functions.returnSrcSet(variantInspectionData[`${selected_variant.id}`]['transparent_image'])
        }
        let ctas = selectionImage.closest('.product-tile').querySelectorAll('.product-tile__swatches-container .product-tile__button')
        
        if(ctas.length > 0 && !ctas[0].getAttribute('data-updated')){
          ctas.forEach((cta) => {
            cta.removeAttribute('data-href');
            cta.removeAttribute('data-url');
            cta.setAttribute('promo-style', true);
            cta.setAttribute('promo-style-on-hover', true);
            cta.setAttribute('href', variantInspectionData[`cta_url`]);
            cta.innerHTML= `<span>${variantInspectionData[`cta_text`]}</span>`
            cta.setAttribute('data-extra-bottom-margin', selectionImage.closest('.product-tile').querySelectorAll('.swatch-element__label').length > 0)
            setTimeout(function() {
              cta.setAttribute('data-updated', true);
            }, 500)
          })
        }
        selectionImageInner.setAttribute('sizes', `(max-width: 600px) 100vw, 60vw`);

        let secondaryImage = selectionImage.closest('.variant-inspect') ? selectionImage.closest('.variant-inspect').querySelector('.variant-inspect__secondary-image-inner-container img') : undefined;
        if(secondaryImage){
          secondaryImage.setAttribute('srcset', window.Branch.functions.returnSrcSet(variantInspectionData[`${selected_variant.id}`]['secondary_image_file_name']));
          secondaryImage.setAttribute('src', variantInspectionData[`${selected_variant.id}`]['secondary_image_file_name']);
        }
        let swatches = selectionImage.closest('.variant-inspect').querySelectorAll('.product-tile .swatch');
        swatches.forEach((swatch, index) => {
          let swatchName = swatch.getAttribute('data-option-name');
          const optionIndex = product.options.findIndex(option => option.replace(/\s+/g, '-').toLowerCase() === swatchName.replace(/\s+/g, '-').toLowerCase());
          swatch.querySelector('.opt-var-name').innerHTML = selected_variant.options[optionIndex];

          /* Hype page */

          if(document.querySelectorAll(`body.template-page-hype-erg #mobile-sticky-atc .swatch-dropdown`).length > 0 && document.querySelectorAll(`body.template-page-hype-erg #mobile-sticky-atc .swatch-dropdown`)[index]){
            let labelText = document.querySelectorAll(`body.template-page-hype-erg #mobile-sticky-atc .swatch-dropdown`)[index].querySelector('.swatch-dropdown__bar-label-text');
            if(labelText.querySelector('.option-name')){
              labelText.querySelector('.option-name').remove();
            }
              let html = `<span class="option-name">: ${selected_variant.options[optionIndex]}</span>`;
              labelText.insertAdjacentHTML('beforeend', html)
          }
        })
      }
    }

    const waitForProduct = function(product_handle) {
      return new Promise((resolve, reject) => {
        const interval = 500; 
        const maxAttempts = 20; 
        let attempts = 0;
    
        const checkProducts = setInterval(() => {
          attempts++;
    
          if (typeof products !== 'undefined') {
            const product = products.find((p) => p.handle === product_handle);
    
            if (product) {
              clearInterval(checkProducts);
              resolve(product); 
              return;
            }
          }
    
          if (attempts >= maxAttempts) {
            clearInterval(checkProducts);
            reject(new Error('Unable to find product after multiple attempts'));
          }
        }, interval);
      });
    }

    const onTileSwatchClick = async function(e, type, swatchesContainerSelector, swatchUnitsSelector, element){
      
      /* Prevent focus on swatch if on hype page */
      if(e && document.querySelectorAll(`body.template-page-hype-erg #mobile-sticky-atc .swatch-dropdown`).length > 0){
        e.preventDefault(); 
      }

      if(e && e.target.closest('.product-tile[data-filter-tile="true"]')){
        e.preventDefault(); 
      }

      let tileId = e && e.target.closest('.product-tile') ? e.target.closest('.product-tile').getAttribute('data-id') : undefined;
      var $product;
      if(e){
        $(e.currentTarget).closest('.swatch[role="group"]').find('.swatch-element').removeClass('selected');
        $(e.currentTarget).closest('.swatch-element').addClass('selected');
        $product = $(e.currentTarget).closest(`${swatchesContainerSelector}`);
      } else {
        $product = element.find(`${swatchesContainerSelector}`);
      }
      let id = $product.closest('.product-tile').attr('data-id');

      var product_handle = $product.data('product-handle'); //ex. 'standing-desk'

      try {
        let product;
        if (hypePageProduct) {
          product = hypePageProduct;
        } else {
          product = await waitForProduct(product_handle);
        }

      if(type == 'tile'){
        // Linked options (only relevant for chair collection)
        $product.find('.swatch.frame .swatch-element').each(function() {
          var $swatch = $(this);

          var seat_color = $product.find('.swatch:first-of-type .selected').data('value');
          var color = $swatch.data('value');
          var matching_variants = product.variants.filter(function(v) {
            return v.options.indexOf(seat_color) !== -1 && v.options.indexOf(color) !== -1;
          });
          
          $swatch[matching_variants.length == 0 ? 'addClass' : 'removeClass']('option-not-available');
          
          var options = $product.find('.swatch-element.selected').map(function() {
            if($(this).hasClass('option-not-available')){
              $(this).removeClass('selected');
              $(this).first().siblings().addClass('selected')
              return $(this).first().siblings().data('value')
            } else {
              return $(this).data('value')
            }
          }).toArray();
       
        });
      }
      if (!products) {
        return;
      }
      
      let selected_variant = undefined;
      let selected_variants_array = [];
      let swatch_units = Array.from(document.querySelectorAll(`${type == "tile" && tileId ? `.product-tile[data-id="${tileId}"]` : ''} ${swatchUnitsSelector.replace('##PRODUCT_HANDLE##', product_handle)}`)).sort(
        (a, b) => parseInt(a.getAttribute('data-option-index')) - parseInt(b.getAttribute('data-option-index'))
      );
      let selectors;
      let options_amount = swatch_units.length;
      let option_1 = options_amount > 0 && Array.from(swatch_units).find(element => element.dataset.optionIndex === "0") && Array.from(swatch_units).find(element => element.dataset.optionIndex === "0").querySelector('.swatch-element.selected') ? Array.from(swatch_units).find(element => element.dataset.optionIndex === "0").querySelector('.swatch-element.selected').getAttribute('data-value') : undefined;
      let option_2 = options_amount > 1 && Array.from(swatch_units).find(element => element.dataset.optionIndex === "1") && Array.from(swatch_units).find(element => element.dataset.optionIndex === "1").querySelector('.swatch-element.selected') ? Array.from(swatch_units).find(element => element.dataset.optionIndex === "1").querySelector('.swatch-element.selected').getAttribute('data-value') : undefined;
      let option_3 = options_amount > 2 && Array.from(swatch_units).find(element => element.dataset.optionIndex === "2") && Array.from(swatch_units).find(element => element.dataset.optionIndex === "2").querySelector('.swatch-element.selected') ? Array.from(swatch_units).find(element => element.dataset.optionIndex === "2").querySelector('.swatch-element.selected').getAttribute('data-value') : undefined;

      if(type != "tile"){
        selectors = document.querySelectorAll(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product_handle}"] .single-option-selector`)

        if(option_1 && selectors[0]){
          selectors[0].value = option_1;
            const event = new Event('change', {
              'bubbles': true,
              'cancelable': true
          });
          selectors[0].dispatchEvent(event);
        }

        if(option_2 && selectors[1]){
          selectors[1].value = option_2;
            const event = new Event('change', {
              'bubbles': true,
              'cancelable': true
          });
          selectors[1].dispatchEvent(event);
        }
      }

      let current_selection = [];
      let swatches;
      if(type == "tile"){
        current_selection.push(...[option_1, option_2, option_3].filter(Boolean));
        swatches = swatch_units;
      } else {
        if(options_amount == 1){
          current_selection = `${option_1}`.split(',');
        } else {
          current_selection = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product_handle}"]`).getAttribute('data-variant-description').split(',')
        }
        swatches = document.querySelectorAll(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product_handle}"] .swatch`);
      }
        for (let length = current_selection.length; length > 0; length--) {
          selected_variant = product && product.variants.find(variant => 
            variant.options.slice(0, length).every((option, index) => option === current_selection[index])
          );
          if (selected_variant) {
            break;
          }
        }

        current_selection.forEach((current_selection_value, selection_index) => {

          swatches[selection_index].querySelectorAll('.swatch-element').forEach((swatchElement) => {
            swatchElement.classList.remove('selected')
          });

          if(swatches[selection_index].querySelector(`.swatch-element[data-value="${current_selection_value}"]`)){
            swatches[selection_index].querySelector(`.swatch-element[data-value="${current_selection_value}"]`).classList.add('selected');
          }
        })
        
      if (selected_variant) {
        if(type != 'tile'){
          let selectInput = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product_handle}"] input#product-${product.id}-variant`);
          selectInput.setAttribute('value', selected_variant.id);

          let selectElement = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product_handle}"] select.select-variant`)
          let optionToSelect = selectElement.querySelector(`option[value='${selected_variant.id}']`);
         
          // console.log('optionToSelect', optionToSelect)

          if (optionToSelect) {
            selectElement.value = selected_variant.id;
            selectElement.setAttribute('value', selected_variant.id);
            selectElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        // Update link to include link to variant
        if(e && e.target.closest('.product-tile')){
          let tileLink = e.target.closest('.product-tile').querySelector('.product-tile__main-link');
          if(tileLink){
            let newLinkUrl = window.Branch.functions.updateVariantParam(tileLink.getAttribute('href'), 'variant', selected_variant.id)
            tileLink.setAttribute('href', newLinkUrl);

            // console.log('newLinkUrl', newLinkUrl)

            e.target.closest('.product-tile').querySelectorAll('.product-tile__button').forEach((button) => {
              button.setAttribute('href', newLinkUrl);
              button.setAttribute('data-href', newLinkUrl);
            })
          }
        }

        if(type == 'tile'){
          let productCard = false;
          if(e){
            productCard = e.target.closest('.product-tile') || e.target.closest('.product-tile-carousel');
          } else if(element) {
            productCard = element[0];
          }
          updateVariantPrice(selected_variant, productCard, product);
          var $btn = $product.find('.btn');
          var href = $btn.data('href');
          // $btn.attr('href', (href + '?variant=' + selected_variant.id));
          
          var $atcBtn = $product.find('.atc');
          $atcBtn.attr('variant-id',selected_variant.id)
        }
        product.selected_variant = selected_variant;
        if(type == 'tile'){

          let selectionImage;
          if(e){
            selectionImage = e.target.closest('.product-tile').querySelector('.product-image');
          } else {
            selectionImage = element[0].querySelector('.product-image');
          }
          let selectionImageInner = selectionImage.querySelector('.product-image-container img');
          let selectionImageHover = selectionImage.querySelector('.product-image-hover');
          let imageData = JSON.parse(document.querySelector(`#image_variant_data-${product.id}`).innerText)[`${selected_variant.id}`];
          let hoverImageSrcSet = window.Branch.functions.returnSrcSet(imageData['ls_img_src'])
          let hoverImageSrc = imageData['bg_img_hov']
          let imageSrcSet = window.Branch.functions.returnSrcSet(imageData['img_src']);
          let saleText  = imageData['sale_text']
          let bgImage  = imageData['bg_image'];

          let variantInspectionSection = selectionImage.closest('.product-tile').getAttribute('variant-inspection-section') == 'true'
          if(variantInspectionSection){
            let variantInspectionData = JSON.parse(document.querySelector(`#variant-inspect-data`).innerText);

            variantInspectSectionSpecialBehaviour(selected_variant, selectionImage, selectionImageInner, variantInspectionData, product);
              if(variantInspectionData && variantInspectionData[`${selected_variant.id}`]){
                imageSrcSet = window.Branch.functions.returnSrcSet(variantInspectionData[`${selected_variant.id}`]['transparent_image'])
              }
              if(hypePage && document.querySelector('#mobile-sticky-atc')){
                let stickyATC = document.querySelector('#mobile-sticky-atc');
                let swatchDropdowns = stickyATC.querySelectorAll(`.swatch-dropdown`);
                swatchDropdowns.forEach((swatchDropdown, index) => {
                  swatchDropdown.querySelector(`.swatch-dropdown__sliding-option-selector-element input[value="${selected_variant.options[index]}"]`).checked = true;
                  let label = stickyATC.querySelectorAll('.swatch-dropdown__bar-element-inner-container .swatch-dropdown__bar-label')[index];

                  let value = selected_variant.options[index];
                  label.setAttribute('data-option-value', `${value.replace(" ", "-").toLowerCase()}`);
                  if(label.getAttribute('data-type') == "color"){
                    label.classList = `swatch-dropdown__bar-label swatch-dropdown__bar-label--selected  color-${value.replaceAll(" ", "-").replaceAll("/", "-").toLowerCase()}`;
                  }
                })
               
              }
          }
          
          selectionImage.setAttribute('data-variant', `${selected_variant.title}`)
          selectionImageInner.setAttribute('srcset', imageSrcSet);


          

          if(selectionImageHover){
            selectionImageHover.querySelector('.product-image-hover__image').setAttribute('src', `${hoverImageSrc}`)
            selectionImageHover.querySelector('.product-image-hover__image').setAttribute('srcset', `${hoverImageSrcSet}`)
          }
        }    
      };
      if(type != 'tile' && selected_variant){
        window.Branch.bundle.updatePricing();
        window.Branch.bundle.updateSummaryTab();
        window.Branch.bundle.updateGalleryImage();
        window.Branch.bundle.updateCTAURLParams();
        window.Branch.bundle.secondaryGalleryImages();

        window.Branch.bundle.updateSelectedAddons();
        window.Branch.bundle.updateSelectedAccessories();
        if(all_images_preloaded == false){
          window.Branch.bundle.bundleBuilderPreloadImages('click')
      }


      let mainProductSwatches = document.querySelectorAll(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product.handle}"] .swatch`);
      let mainProductSwatchesFirstContainer = document.querySelector(`.bundle-builder-form__product-variants-inner-container[data-product-handle="${product.handle}"]`);

      var variantTextReplacementMetafield = mainProductSwatchesFirstContainer.getAttribute('data-words-to-be-removed-from-variant-title') ? mainProductSwatchesFirstContainer.getAttribute('data-words-to-be-removed-from-variant-title').split(",") : undefined;
      window.Branch.product.updateVariantSwatchTitles(mainProductSwatches, selected_variant, product.id, variantTextReplacementMetafield);
      }
        


      } catch (error) {
        console.error(error);
        // Handle the error appropriately
      }

        var product = products.find(function(p) {return p.handle == product_handle});

        
    }


    window.Branch = window.Branch || {};
    window.Branch.product = window.Branch.product || {};

     window.Branch.product.variantSelection = function(type, variantSelectObject) {
        let onClickSelector = variantSelectObject['onClickSelector'];


        $(document).on('click',`${onClickSelector}`, function(e) {   
          let swatchesContainerSelector = variantSelectObject['swatchesContainerSelector'];
          let swatchUnitsSelector = variantSelectObject['swatchUnitsSelector']
          onTileSwatchClick(e, type, swatchesContainerSelector, swatchUnitsSelector)
        });
       }
    
      const updateVariantPrice = function(selected_variant, productCard, product){
        let originalPrice;
        let currentPrice = selected_variant.price;
        let discountPercentage;
    
        if(productCard){
          if (productCard.getAttribute('data-discount-amount')){
            discountPercentage = productCard.getAttribute('data-discount-amount');
          }
        }
    
        if(selected_variant.compare_at_price && selected_variant.compare_at_price > currentPrice) {
          originalPrice = selected_variant.compare_at_price;
        } 
        
        if (discountPercentage > 0){
          if(!originalPrice){
            originalPrice = currentPrice;
          } 
          currentPrice = (currentPrice * (100 - discountPercentage)/100);
        }
    
        let currentPriceElement = productCard.querySelector('span[data-price="deal"]');
        let originalPriceElement = productCard.querySelector('span[data-price="retail"]');
        let messageElement = productCard.querySelector('div.price__discount-message');
    

        let priceData =  JSON.parse(document.querySelector(`.per-variant-pricing[data-product-handle="${product.handle}"]`).innerText)[`${selected_variant.id}`];
        let originalPriceFromData = priceData.opx;
        let currentPriceFromData = priceData.cpx;
        let discountCodeMessage = '';
        let saleText = priceData.ss;
        
        const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(currentPriceFromData, originalPriceFromData, 0, '', product.handle);
        originalPriceFromData = codeDiscountData.originalPrice;
        currentPriceFromData = codeDiscountData.currentPrice;
        discountCodeMessage = codeDiscountData.discountMessage;

        // console.log('handle', product.handle)
    
        let plus = productCard.querySelector('span.plus');

        // let saleLabel = productCard.querySelector('.sale');

        let priceVaries = currentPriceElement.closest('.price') && currentPriceElement.closest('.price').getAttribute('data-price-varies') == 'true' ? true : false;
        currentPriceElement.innerHTML = `${Shopify.formatMoney((100 * Math.round(currentPriceFromData / 100)), Simplistic.formatMoney).replace('.00', '').replace(' ','')}`+`${priceVaries == true ? '+' : ''}`;
        
        if(plus) { 
          plus.innerHTML = '';
        };
        let selectionImageSale = productCard.querySelector('.product-image .sale');

        if(selectionImageSale && selectionImageSale.getAttribute('data-sale-text') != ''){
          saleText = selectionImageSale.getAttribute('data-sale-text');
        }
        if(selectionImageSale){
            let percentageDiscount = originalPriceFromData ? Math.round(100 * ((originalPriceFromData - currentPriceFromData) / originalPriceFromData)) : 0;
            if(percentageDiscount > 0){
              selectionImageSale.innerHTML = `save ${percentageDiscount}%`;
              selectionImageSale.setAttribute('data-sale-text', `save ${percentageDiscount}%`);
              selectionImageSale.setAttribute('data-display', true);
            } else if (saleText && saleText != "" && saleText != "n") {
              selectionImageSale.setAttribute('data-sale-text', `${saleText.replaceAll('*', ' ')}`)
              selectionImageSale.innerHTML = `${saleText.replaceAll('*', ' ')}`;
              selectionImageSale.setAttribute('data-display', true);
            } else {
              selectionImageSale.setAttribute('data-display', false);
              selectionImageSale.setAttribute('data-display-extra', false);
            }

          let productHandle = selectionImageSale.getAttribute('data-product-handle');
          if(discountCodeDataForTiles.discount_code_1_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeDataForTiles.discount_code_1_amount != undefined && discountCodeDataForTiles.discount_code_1_amount > 0){
            if(discountCodeDataForTiles.discount_code_1_special_swatch_text != ""){
              selectionImageSale.innerHTML = `${discountCodeDataForTiles.discount_code_1_special_swatch_text}`;
              selectionImageSale.setAttribute('data-sale-text', `${discountCodeDataForTiles.discount_code_1_special_swatch_text}`);
            }
          } else if(discountCodeDataForTiles.discount_code_2_product_handles.replaceAll(' ', '').split(",").includes(productHandle) && discountCodeDataForTiles.discount_code_2_amount != undefined && discountCodeDataForTiles.discount_code_2_amount > 0){
            if(discountCodeDataForTiles.discount_code_2_special_swatch_text != ""){
              selectionImageSale.innerHTML = `${discountCodeDataForTiles.discount_code_2_special_swatch_text}`;
              selectionImageSale.setAttribute('data-sale-text', `${discountCodeDataForTiles.discount_code_2_special_swatch_text}`);
            }
          }
          
        }
    
        if(originalPriceFromData && originalPriceFromData !== "" && originalPriceFromData != currentPriceFromData){
          originalPriceElement.innerHTML = `<s>${Shopify.formatMoney((100 * Math.round(originalPriceFromData / 100)), Simplistic.formatMoney).replace('.00', '').replace(' ','')}</s>`;
          originalPriceElement.closest('.retail').setAttribute('data-visible', 'true');

        } else {
          originalPriceElement.innerHTML = '<s></s>'
          originalPriceElement.closest('.retail').setAttribute('data-visible', 'false')
        }
    
        if(discountCodeMessage && discountCodeMessage !== ""){
          messageElement.innerHTML = discountCodeMessage;
        } else {
          messageElement.innerHTML = ''
        }
      }

      const initSwatchFormat = function(){
        var windowWidth = window.innerWidth

        let format_options = {};
        format_options['swatches_selector'] = `.product-tile__swatches-container .swatches-container__color-swatches-container`;
        format_options['swatches_container_parent_selector'] = '.product-tile__swatches-container';
        format_options['not_hidden_button_container'] = '.product-tile__button:not(.hide)';
        format_options['swatch_width'] = 24;
        format_options['divider_width'] = 41;

        window.Branch.product.formatSwatches(format_options)

        if(document.querySelectorAll('.product-tile__swatches-container').length > 0){
          var timeOutFunctionId; 
          window.addEventListener("resize", function() { 
            clearTimeout(timeOutFunctionId); 
            timeOutFunctionId = setTimeout(function(){
              if (window.innerWidth != windowWidth) {
                windowWidth = window.innerWidth
                window.Branch.product.formatSwatches(format_options)
              }
            }, 500); 
        }); 
        }
      }
      
      


  function initImagePreLoad(){
    let imageTilesWithSwatches = document.querySelectorAll('.product-tile[data-swatches="true"]');
    if(imageTilesWithSwatches.length > 0){
      imageTilesWithSwatches.forEach((imageTileWithSwatches) => {
          let swatchesContainer = imageTileWithSwatches.querySelector('.product-tile__swatches-container');
          if(swatchesContainer){
            let swatch_tile_product_handle = swatchesContainer.getAttribute('data-product-handle');
            let swatch_tile_product = products.find(function(p) {return p.handle == swatch_tile_product_handle});
            if(hypePageProduct){
              swatch_tile_product = hypePageProduct
            }

            let tileSwatchesContainerSelector = `.product-tile[data-id="${imageTileWithSwatches.getAttribute('data-id')}"] .product-tile__swatches-container[data-product-handle="${swatch_tile_product_handle}"]`;
            
            window.Branch.product.initSwatchClickListener(swatch_tile_product, true, 'tile', tileSwatchesContainerSelector);
            window.Branch.product.preloadImages(swatch_tile_product, 'init', 'tile', tileSwatchesContainerSelector);
          }
        })
      }
    }

    window.Branch = window.Branch || {};
    window.Branch.collection = window.Branch.collection || {};

    window.Branch.collection.updateDisabledSwatchedPrice = function(tile, priceData, type, handle, variantId, origin){
      if(tile){
        let percentageDiscount = 0;
        let originalPrice = 0;
        let currentPrice = 0;
        if(type == 'regular'){
          if(tile.querySelector('.price') && tile.querySelector('.price').getAttribute('data-legacy-bundle') == 'true'){
            let priceElement = tile.querySelector('.price');
            let constituentProduct1Quantity = parseInt(priceElement.getAttribute('constituent-product-1-quantity'));
            let constituentProduct2Quantity = parseInt(priceElement.getAttribute('constituent-product-2-quantity'));

            let constituentPrices = [
              {"handle": priceElement.getAttribute('constituent-product-1-handle'), "currentPrice": parseInt(priceElement.getAttribute('constituent-product-1-price')) * constituentProduct1Quantity, "originalPrice": parseInt(priceElement.getAttribute('constituent-product-1-compare-at-price')) * constituentProduct1Quantity},
              {"handle": priceElement.getAttribute('constituent-product-2-handle'), "currentPrice": parseInt(priceElement.getAttribute('constituent-product-2-price')) * constituentProduct2Quantity, "originalPrice": parseInt(priceElement.getAttribute('constituent-product-2-compare-at-price')) * constituentProduct2Quantity}
            ];

            if(handle == "cable-organizer" || handle == "open-box-cable-organizer"){
                if(priceData && priceData[variantId] && priceData[variantId].constituents && priceData[variantId].constituents.length == 1){
                constituentPrices = [
                  {"handle": priceElement.getAttribute('constituent-product-1-handle'), "currentPrice": parseInt(priceElement.getAttribute('constituent-product-1-price')) * constituentProduct1Quantity, "originalPrice": parseInt(priceElement.getAttribute('constituent-product-1-compare-at-price')) * constituentProduct1Quantity}
                ];
                }
              };

            constituentPrices.forEach((constituentPrice, constituentIndex) => {
              let bundleDiscountAmount = 5;
              if(handle == "cable-organizer" || handle == "open-box-cable-organizer"){
                bundleDiscountAmount = 0;
              };
                            
              const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(constituentPrice.currentPrice, constituentPrice.originalPrice, 0, '', constituentPrice.handle);
              let codeDiscountAmountPercentage = codeDiscountData['discountAmount'] > 0 ? ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + bundleDiscountAmount : 0 + bundleDiscountAmount;
              // console.log('codeDiscountAmountPercentage', codeDiscountAmountPercentage);

              originalPrice = originalPrice + codeDiscountData.originalPrice;
              currentPrice = currentPrice + ((constituentPrice.currentPrice) * ((100 - codeDiscountAmountPercentage)/ 100));
            });
              // console.log('constituentPrices', constituentPrices)
          } else {
            let currentPriceElement = tile.querySelector(origin == 'shopBySpaces' ? '.shop-by-spaces-hero__clickable-link-product-price:not(.shop-by-spaces-hero__clickable-link-product-price-original)' : '.price .deal');
            let originalPriceElement = tile.querySelector(origin == 'shopBySpaces' ? '.shop-by-spaces-hero__clickable-link-product-price-original' : '.price .retail');
            if(variantId && priceData && priceData[variantId]){
              currentPrice = priceData[variantId].cpx;
              originalPrice = priceData[variantId].opx;
            } else {
              currentPrice = parseInt(currentPriceElement.getAttribute('data-price'));
              originalPrice = parseInt(originalPriceElement.getAttribute('data-price'));
            }
            
          }
          ({ currentPrice, originalPrice } = window.Branch.functions.returnDiscountCodeUpdates(parseInt(currentPrice), parseInt(originalPrice), 0, '', handle ? handle : tile.querySelector('.price').getAttribute('data-product-handle')));
        } else if(type == 'preset_bundle'){
          for (const handle in priceData) {
              const { price, original_price } = priceData[handle];
              let finalPrice = price;
          
              let codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(parseInt(price), parseInt(original_price), 0, '', handle);
              let codeDiscountAmountPercentage = ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + 5;
              originalPrice = originalPrice + codeDiscountData.originalPrice;
              currentPrice = currentPrice + parseInt(price) * ((100 - codeDiscountAmountPercentage)/ 100);

          disabledSwatchTileData[`${handle}`] = {'currentPrice': currentPrice, 'originalPrice': originalPrice, 'percentageDiscount': percentageDiscount}
        }   
      }          
      if(origin == 'shopBySpaces'){
        tile.querySelector('.shop-by-spaces-hero__clickable-link-product-price:not(.shop-by-spaces-hero__clickable-link-product-price-original)').innerHTML = `${Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')}${variantId ? '' : '+'}`;
        tile.querySelector('.shop-by-spaces-hero__clickable-link-product-price-original').innerHTML = `${Shopify.formatMoney(originalPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')}`;
        if(currentPrice < originalPrice){
          tile.querySelector('.shop-by-spaces-hero__clickable-link-product-price-original').style.display = 'block';
        }
      } else {
        tile.querySelector('.price span[data-price="deal"]').innerHTML = `${Shopify.formatMoney(currentPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')}${variantId ? '' : '+'}`;
        tile.querySelector('.price span[data-price="retail"]').innerHTML = `${Shopify.formatMoney(originalPrice, Simplistic.formatMoney).split('.')[0].replace(' ','')}`;

        if(currentPrice < originalPrice && tile.querySelector('.price .retail')){
          percentageDiscount = Math.round(100 * (originalPrice - currentPrice) / originalPrice);

          tile.querySelector('.price .retail').setAttribute('data-visible', true);

          if(tile.querySelectorAll('.sale').length > 0){
            tile.querySelectorAll('.sale').forEach((saleTag) => {
              let saleTagText = `save ${percentageDiscount}%`
              if(saleTag.closest('.product-image') && saleTag.closest('.product-image').getAttribute('data-swatch-text')){
                saleTagText = saleTag.closest('.product-image').getAttribute('data-swatch-text');
              } 
                
              saleTag.innerHTML = saleTagText;
              saleTag.setAttribute('data-display', true);
              saleTag.setAttribute('data-sale-text', saleTagText);
              saleTag.setAttribute('data-special', saleTagText);
              
            })
            
          } else {
            let saleTagText = `save ${percentageDiscount}%`
            if(tile.querySelector('.product-image') && tile.querySelector('.product-image').getAttribute('data-swatch-text')){
              saleTagText = tile.querySelector('.product-image').getAttribute('data-swatch-text');
            } 
            let saleTagHtml = `<div data-display="true" data-dc-text="true" data-sale-text="${saleTagText}" class="sale">${saleTagText}</div>`;
            if(tile.querySelector('.product-image-container')){
              tile.querySelector('.product-image-container').insertAdjacentHTML('afterend', saleTagHtml);
            }
          }
        }
      }
        
      }
    }

    window.Branch.collection.updateAllBundleBuilderGridTiles = function(type, mainSelector){
      let bundleBuilderGridTiles = document.querySelectorAll(`${mainSelector}[data-bundle-builder-tile="true"]`);
      bundleBuilderGridTiles.forEach((tile) => {
        let totalCurrentPrice = 0;
        let totalOriginalPrice = 0;
        let mainProductHandle = tile.getAttribute('data-bundle-builder-tile-base-product-handle');
        let data = JSON.parse(document.querySelector(`.bundle-builder-grid-tile-price-data[data-bundle-builder-tile-base-product-handle="${mainProductHandle}"]`).innerText);
        let handles = [data['chair-product']['handle'], data['desk-product']['handle']];
        let lowestPricedVariants = [Object.values(data['chair-product']['data']).reduce((lowest, obj) => obj.cpx < lowest.cpx ? obj : lowest), Object.values(data['desk-product']['data']).reduce((lowest, obj) => obj.cpx < lowest.cpx ? obj : lowest)];
        lowestPricedVariants.forEach((variant, index) => {
          // console.log('variant!!', variant)
          const codeDiscountData = window.Branch.functions.returnDiscountCodeUpdates(variant.cpx, variant.opx, 0, '', handles[index]);
            let codeDiscountAmountPercentage = ((codeDiscountData.originalPrice - codeDiscountData.currentPrice) / codeDiscountData.originalPrice) * 100 + 5;
            // console.log('codeDiscountAmountPercentage', codeDiscountAmountPercentage)
            totalOriginalPrice = totalOriginalPrice + codeDiscountData.originalPrice;
            totalCurrentPrice = totalCurrentPrice + variant.cpx * ((100 - codeDiscountAmountPercentage)/ 100);
        })
        if(type == 'product-tile'){
          tile.querySelector('.price').setAttribute('data-initialized', true);
          tile.querySelector('.price .retail').setAttribute('data-visible', true);
          tile.querySelector('.price .retail span[data-price="retail"]').innerHTML = `${Shopify.formatMoney(Math.ceil(totalOriginalPrice/100)*100, Simplistic.formatMoney).replace('.00', '').replace(' ','')}`;
          tile.querySelector('.price .deal span[data-price="deal"]').innerHTML = `${Shopify.formatMoney(Math.ceil(totalCurrentPrice/100)*100, Simplistic.formatMoney).replace('.00', '').replace(' ','')}+`;
        }
        let message = `save ${Math.ceil(((totalOriginalPrice - totalCurrentPrice) / totalOriginalPrice) * 100)}%`
        let labelHTML = `<div data-dc-text="false" data-sale-text="${message}" class="sale">${message}</div>`
        tile.querySelector(`${type == 'product-tile' ? '.product-tile__image-container' : '.menu-mobile-improved__sub-nav-item-image-container, .menu-mobile-improved-legacy__sub-nav-item-image-container'}`).insertAdjacentHTML(`${type == "product-tile" ? 'afterbegin' : 'beforeend'}`, labelHTML);
      });
    }

    const returnVariantSelectObject = function() {
      let variantSelectObject = {};
      variantSelectObject['onClickSelector'] = '.product-tile .swatch-element label';
      variantSelectObject['swatchesContainerSelector'] = '.product-tile__swatches-container';
      variantSelectObject['swatchUnitsSelector'] = '.product-tile__swatches-container[data-product-handle="##PRODUCT_HANDLE##"] .swatches-container .swatch';
      return variantSelectObject;
    }

    const clickOnFirstSwatchOfAll = function(){
      let allProductTiles = $('.product-tile');
      allProductTiles.each(function() {
          if($(this).find('.swatches-container .swatch').length > 0) {
              onTileSwatchClick(null, 'tile', '.product-tile__swatches-container', '.product-tile__swatches-container[data-product-handle="##PRODUCT_HANDLE##"] .swatches-container .swatch', $(this));
          }
      });
  };

    function initProductTiles(){
        let productPage = document.querySelector('body').classList.contains('templateProduct');
        let variantSelectObject = returnVariantSelectObject();
        if(document.querySelectorAll('.product-tile').length > 0){
          initShowMore();
          window.Branch.product.variantSelection('tile', variantSelectObject);
        }
        initSwatchFormat();
        initImagePreLoad();
        clickOnFirstSwatchOfAll()
    }
    initProductTiles();
})

